// extracted by mini-css-extract-plugin
export var label = "styles-module__label___bbdBg";
export var checkboxRoot = "styles-module__checkboxRoot___a2zQT";
export var checked = "styles-module__checked___mT9J6";
export var ssrSpacer = "styles-module__ssrSpacer___VNFm7";